import { withTranslation } from "next-i18next";
import { useState, useEffect, useRef } from "react";
import { getProductSuggestions } from "@utils/call-api/products-call";
import Slider from "@components/core/Slider";
import ProductSuggestionCard from "./ProductSuggestionCard";

function ProductSuggestions({ product, context, t }) {
  const [suggestions, setSuggestions] = useState({});

  const productSliderRef = useRef();

  function setSliderRef(ref) {
    productSliderRef.current = ref;
  }

  const cards = () => {
    const products = [];

    suggestions.products_look?.data?.forEach((look) => {
      products.push(
        <ProductSuggestionCard
          key={look.id}
          product={look}
          context={context}
          metaAlgolia={{}}
          isLook
        />,
      );
    });

    suggestions.products_similar?.data?.forEach((productSimilar, index) => {
      products.push(
        <ProductSuggestionCard
          key={productSimilar.id}
          product={productSimilar}
          context={context}
          metaAlgolia={suggestions.products_similar.meta.algolia}
          position={index + 1 + suggestions.products_look?.data?.length}
        />,
      );
    });

    return products;
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productSuggestionsRes = await getProductSuggestions(product.slug);

        setSuggestions(productSuggestionsRes);
      } catch (err) {
        console.log({ err });
      }
    };
    fetchProducts();
  }, [product.slug]);

  if (!suggestions.products_look?.data?.length && !suggestions.products_similar?.data?.length)
    return null;

  return (
    <div className="py-4 bg-white">
      <div className="py-2 mt-lg-3">
        <h5 className="mb-4 text-center">{t("product:suggestions_title")}</h5>

        <div className="d-flex justify-content-center w-100">
          <div className="product-suggestions-container">
            <Slider
              name="product-suggestions"
              setSliderRef={setSliderRef}
              cards={cards()}
              productSliderRef={productSliderRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductSuggestions);
